import {
  FulfillmentMethod,
  OfferedFulfillmentMethod,
  hasOfferedFulfillment,
  offersPickup,
  offersShipping,
  supportsFulfillment,
} from "@simplyk/common";

import { TicketingFrontendPageOutput } from "@/common/types/trpc";

export const useCommandFulfillmentVisibility = (
  ticketing: TicketingFrontendPageOutput,
  hasAlreadyProvidedFulfillment = false
) => {
  const offered = ticketing.offeredFulfillmentMethods ?? [];
  const enabled =
    supportsFulfillment(ticketing.formCategory) && hasOfferedFulfillment(offered) && !hasAlreadyProvidedFulfillment;
  const pickupOnly = enabled && offersPickup(offered) && !offersShipping(offered);
  const shippingOnly = enabled && offersShipping(offered) && !offersPickup(offered);
  const showFulfillmentOnPayment = enabled;
  const showDeliveryMethodChoice = enabled && offersPickup(offered) && offersShipping(offered);

  const defaultFulfillmentMethod = shippingOnly
    ? FulfillmentMethod.Shipping
    : pickupOnly
      ? FulfillmentMethod.Pickup
      : undefined;

  return {
    enabled,
    pickupOnly,
    shippingOnly,
    showFulfillmentOnPayment,
    showDeliveryMethodChoice,
    defaultFulfillmentMethod,
    shippingFeeAmount: ticketing.shippingFeeAmount ?? 0,
    offeredMethods: offered as OfferedFulfillmentMethod[],
  };
};

export type CommandFulfillmentVisibility = ReturnType<typeof useCommandFulfillmentVisibility>;
